// extracted by mini-css-extract-plugin
export var content = "TwoColumnImage-module--content--4fded";
export var image = "TwoColumnImage-module--image--2aa49";
export var info = "TwoColumnImage-module--info--a3aa9";
export var intro = "TwoColumnImage-module--intro--43e8b";
export var textHolder = "TwoColumnImage-module--textHolder--1c976";
export var wrapper = "TwoColumnImage-module--wrapper--e2d5c";